import { Component, Input } from '@angular/core';
import { CopyTextComponent } from '@tecalisdev/infinity';
import { truncateUUID } from '../../../core/utils/utils';

@Component({
	selector: 'app-uuid-display',
	imports: [CopyTextComponent],
	templateUrl: './uuid-display.component.html',
	styleUrl: './uuid-display.component.scss',
})
export class UuidDisplayComponent {
	@Input() uuid: string = '';

	private truncateLength = 8;

	public truncateUUID(uuid: string): string {
		return truncateUUID(uuid, this.truncateLength, this.truncateLength);
	}
}
